/* DartCase Studio: native Liquid remains the source of product, price and cart data. */
(() => {
  'use strict';
  const q = (selector, parent = document) => parent.querySelector(selector);
  const qa = (selector, parent = document) => Array.from(parent.querySelectorAll(selector));
  const money = cents => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  const rootPath = (document.body.dataset.rootUrl || '/').replace(/\/?$/, '/');
  const route = path => `${rootPath}${path}`;
  const showError = (el, message) => { if (el) { el.textContent = message; el.hidden = !message; } };
  const productionFormData = form => {
    const data = new FormData(form);
    // Shopify keeps this order on the order page and its printout, independently of the controls' layout.
    const plaqueFields = [
      'Textlogo', 'Textlogo Zeile 2', 'Text', 'Text2', 'Text 1', 'Text Dartstaender',
      'Schrift', 'Schriftart', 'font',
      'Textfarbe', 'Schriftfarbe', 'color1', 'color2', 'Plakettenfarbe', 'Hintergrundfarbe',
      'customization',
    ];
    const details = [];
    for (const name of plaqueFields.map(key => `properties[${key}]`)) {
      for (const value of data.getAll(name)) details.push([name, value]);
      data.delete(name);
    }
    // Keep product assignment and part colors first, followed by text, font and plaque colors.
    for (const [name, value] of details) data.append(name, value);
    return data;
  };
  const colors = [
    ['Schwarz', 'schwarz', '#202124'], ['Weiß', 'weiss', '#f1f0e9'], ['Rot', 'rot', '#d83a43'],
    ['Grün', 'gruen', '#24965a'], ['Blau', 'blau', '#2764c8'], ['Orange', 'orange', '#f06c25'],
    ['Lila', 'lila', '#7444b8'], ['Gelb', 'gelb', '#ebc52c'], ['Rosa', 'rosa', '#e35393'],
    ['Bronze', 'bronze', '#9d6338'], ['Silber', 'silber', '#aeb5be'], ['Gold', 'gold', '#c79b32'],
  ];
  const normalizedColor = value => {
    const key = String(value || '').trim().toLocaleLowerCase('de-DE').replaceAll('ä','ae').replaceAll('ö','oe').replaceAll('ü','ue').replaceAll('ß','ss');
    return colors.find(color => color[1] === key || (key === 'pink' && color[1] === 'rosa'));
  };
  const colorByName = name => normalizedColor(name) || colors[0];
  const createSwatch = color => {
    const button = document.createElement('button'); button.type = 'button'; button.className = 'swatch';
    button.setAttribute('aria-label', color[0]); button.title = color[0]; button.style.setProperty('--swatch', color[2]);
    if (['Weiß','Gelb','Silber','Gold'].includes(color[0])) button.style.setProperty('--check', '#181a17');
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 32 32'); svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
    [['swatch-ring', 15.5], ['swatch-color', 13], ['swatch-check', 2.5]].forEach(([className, radius]) => {
      const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      circle.setAttribute('class', className); circle.setAttribute('cx', '16'); circle.setAttribute('cy', '16'); circle.setAttribute('r', String(radius)); svg.append(circle);
    });
    button.append(svg);
    return button;
  };
  const menuToggle = q('[data-menu-toggle]');
  const menu = q('#mobile-nav');
  const toggleMenu = open => {
    if (!menu || !menuToggle) return;
    menu.hidden = !open;
    menuToggle.setAttribute('aria-expanded', String(open));
    menuToggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
  };
  menuToggle?.addEventListener('click', () => toggleMenu(menuToggle.getAttribute('aria-expanded') !== 'true'));
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && menu && !menu.hidden) { toggleMenu(false); menuToggle.focus(); } });
  q('[data-sort]')?.addEventListener('change', event => event.target.form.requestSubmit());
  const contactTopic = new URLSearchParams(location.search).get('topic');
  if (contactTopic && q('#contact-subject')) {
    const subject=q('#contact-subject'),value=contactTopic==='premium'?'DartCase 6.0 Premium':contactTopic.slice(0,150);
    if(!Array.from(subject.options).some(option=>option.value===value)){const option=document.createElement('option');option.value=value;option.textContent=value;subject.append(option);}
    subject.value=value;
  }

  function randomizeProducts(scope = document) {
    qa('[data-random-products]', scope).forEach(grid => {
      if (grid.dataset.randomized) return;
      const cards = Array.from(grid.children).flatMap(child => child.tagName === 'TEMPLATE' ? Array.from(child.content.children) : [child]);
      for (let index = cards.length - 1; index > 0; index--) {
        const other = Math.floor(Math.random() * (index + 1));
        [cards[index], cards[other]] = [cards[other], cards[index]];
      }
      grid.replaceChildren(...cards.slice(0, Number(grid.dataset.count) || 3));
      grid.dataset.randomized = 'true';
    });
  }
  randomizeProducts();
  document.addEventListener('shopify:section:load', event => randomizeProducts(event.target));

  const productRoot = q('[data-product-root]');
  if (productRoot) initProduct(productRoot);
  function initProduct(root) {
    const form = q('#product-form', root), select = q('[data-variant-select]', root);
    if (!form || !select) return;
    let product;
    try { product = JSON.parse(q('[data-product-json]', root).textContent); } catch { return; }
    const variants = product.variants || [], model = root.dataset.model;
    const definition = window.DartcaseModels?.[product.handle];
    const configurable = Boolean(definition);
    const needsApproval = root.dataset.requiresApproval === 'true';
    const addonData = q('[data-plaque-addon]', root);
    let plaqueAddon = null;
    try { if (addonData) plaqueAddon = JSON.parse(addonData.textContent); } catch { /* Keep unavailable add-ons disabled. */ }
    const addonAvailable = () => Boolean(plaqueAddon?.id && plaqueAddon.available && plaqueAddon.price > 0);
    const personalize = q('[data-personalize]', root), nameFields = q('[data-name-fields]', root);
    const nameInput = q('[data-name-input]', root), secondInput = q('#plaque-second', root);
    const fontSelect = q('#plaque-font', root), plaqueColor = q('#plaque-color', root), textColor = q('#text-color', root);
    const error = q('[data-product-error]', root), addButton = q('[data-add]', root), addLabel = q('[data-add-label]', root);
    const params = new URLSearchParams(location.search);
    const variantOptions = variant => variant?.options || [variant?.option1, variant?.option2, variant?.option3].filter(value => value != null);
    const optionNames = (product.options || []).map(option => typeof option === 'string' ? option : option.name);
    const selectedVariant = () => variants.find(variant => String(variant.id) === select.value);
    const personalizationIndex = optionNames.findIndex((_, index) => variants.some(variant => variantOptions(variant)[index] === 'Mit Textlogo'));
    const colorIndex = model === 'butler' ? optionNames.findIndex((_, index) => index !== personalizationIndex && variants.some(variant => normalizedColor(variantOptions(variant)[index]))) : -1;
    const currentOptions = [...variantOptions(selectedVariant() || variants[0])];
    let textReady = !personalize;
    const galleryImage = q('[data-gallery-image]', root), galleryButtons = qa('[data-gallery-src]', root);
    let photoMode = !configurable;
    const setPhoto = (src, alt = product.title) => {
      if (!src || !galleryImage) return;
      photoMode = true; galleryImage.src = src; galleryImage.alt = alt; galleryImage.hidden = false;
      const base = q('[data-stage-base]', root), layers = q('[data-stage-layers]', root), plaque = q('[data-stage-plaque]', root);
      if (base) base.hidden = true;
      if (layers) layers.hidden = true;
      if (plaque) plaque.setAttribute('hidden', '');
      galleryButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gallerySrc === src)));
      if (configurable) {
        qa('[data-view]', root).forEach(button => { button.classList.remove('active'); button.setAttribute('aria-pressed', 'false'); });
        q('[data-preview-note]', root).textContent = 'Originalfoto. Die gewählten Farben siehst du in der digitalen Vorschau.';
      }
    };
    galleryButtons.forEach(button => button.addEventListener('click', () => setPhoto(button.dataset.gallerySrc, q('img', button)?.alt)));
    const updatePrice = () => {
      const variant = selectedVariant();
      if (!variant) {
        if (addButton) addButton.disabled = true;
        q('[data-price]', root).textContent = '—';
        if (q('[data-button-price]', root)) q('[data-button-price]', root).textContent = '';
        if (addLabel) addLabel.textContent = 'Nicht kombinierbar';
        return;
      }
      const price = variant.price + (addonData && personalize?.checked && addonAvailable() ? plaqueAddon.price : 0);
      q('[data-price]', root).textContent = money(price);
      if (q('[data-button-price]', root)) q('[data-button-price]', root).textContent = money(price);
      if (addButton) addButton.disabled = needsApproval || !variant.available || !textReady;
      if (addLabel) addLabel.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
      if (!configurable) {
        const photo = variant.featured_image || variant.featured_media?.preview_image;
        if (photo) setPhoto(typeof photo === 'string' ? photo : photo.src || photo.url);
      }
    };
    const nativeControls = [];
    let syncSimpleText = () => {};
    const nativeHost = q('[data-native-options]', root);
    optionNames.forEach((name, index) => {
      const values = [...new Set(variants.map(variant => variantOptions(variant)[index]).filter(value => value != null))];
      if ((values.length === 1 && values[0] === 'Default Title') || (personalize && index === personalizationIndex) || (model === 'butler' && index === colorIndex)) return;
      const group = document.createElement('div'); group.className = 'native-option';
      const label = document.createElement('label'); label.htmlFor = `native-option-${index}`; label.textContent = name;
      const input = document.createElement('select'); input.id = label.htmlFor; input.dataset.optionIndex = String(index);
      values.forEach(value => { const option = document.createElement('option'); option.value = value; option.textContent = value; input.append(option); });
      input.value = currentOptions[index];
      input.addEventListener('change', () => {
        currentOptions[index] = input.value;
        const variant = variants.find(candidate => variantOptions(candidate).every((value, i) => value === currentOptions[i]));
        select.value = variant ? String(variant.id) : '';
        showError(error, variant ? '' : 'Diese Kombination ist nicht verfügbar. Bitte ändere eine Auswahl.');
        syncSimpleText(); updatePrice();
      });
      group.append(label, input); nativeHost.append(group); nativeControls.push(input);
    });
    nativeHost.hidden = nativeControls.length === 0;
    // The real variant ID remains the only source of price, inventory and checkout identity.
    if (nativeControls.length || configurable || personalize || (variants.length===1 && variants[0].title==='Default Title')) form.classList.add('enhanced');
    select.addEventListener('change', () => {
      const variant = selectedVariant();
      variantOptions(variant).forEach((value, index) => { currentOptions[index] = value; });
      nativeControls.forEach(input => { input.value = currentOptions[Number(input.dataset.optionIndex)]; });
      syncSimpleText(); updatePrice();
    });
    const targetField = q('#service-target', root);
    if (targetField && params.get('for')) targetField.value = params.get('for').slice(0, 100);
    qa('[data-required-print-text]', root).forEach(input => input.addEventListener('input', () => input.setCustomValidity('')));

    qa('[data-text-color-group]', root).forEach(group => {
      const input = q('select', group), label = q('label', group), host = q('[data-text-swatches]', group);
      const title = label.textContent;
      const swatches = colors.map(color => {
        const button = createSwatch(color);
        button.addEventListener('click', () => { input.value = color[0]; input.dispatchEvent(new Event('change', {bubbles:true})); });
        host.append(button); return button;
      });
      const update = () => {
        label.textContent = `${title}: ${input.value}`;
        swatches.forEach((button, index) => button.setAttribute('aria-pressed', String(colors[index][0] === input.value)));
      };
      input.hidden = true; host.hidden = false;
      input.addEventListener('change', update); update();
    });
    const syncNameFields = () => {
      nameFields.hidden = !personalize.checked;
      qa('input,select,button', nameFields).forEach(input => { input.disabled = !personalize.checked; });
      nameInput.required = personalize.checked;
      nameInput.setCustomValidity('');
    };
    const inlinePlaque = q('[data-inline-plaque]', root);
    const plaqueSize = definition?.textPlaque || (/3[.-]2/.test(product.handle + ' ' + product.title)
      ? {widthMm:118.45,heightMm:37} : {widthMm:60,heightMm:25});
    const measureContext = document.createElement('canvas').getContext('2d');
    function drawPlaque(svg, lines) {
      const {widthMm, heightMm} = plaqueSize;
      const background = q('rect', svg), group = q('[data-plaque-text]', svg) || q('[data-plaque-transform]>g', svg);
      background.setAttribute('width', String(widthMm)); background.setAttribute('height', String(heightMm));
      background.setAttribute('fill', colorByName(plaqueColor.value)[2]);
      group.setAttribute('fill', colorByName(textColor.value)[2]);
      const family = fontSelect.value === 'Script' ? 'Pacifico, cursive' : 'Arial, sans-serif';
      const weight = fontSelect.value === 'Script' ? '400' : fontSelect.value === 'Fett' ? '900' : '500';
      group.setAttribute('font-family', family); group.setAttribute('font-weight', weight);
      const hasSecond = Boolean(lines[1]);
      let size = heightMm * (hasSecond ? .336 : .6);
      if (measureContext) {
        measureContext.font = `${weight} 100px ${family}`;
        const width = Math.max(...lines.map(line => measureContext.measureText(line).width), 1);
        size = Math.min(size, (widthMm - 6) * 100 / width);
      }
      qa('[data-plaque-line]', svg).forEach((line, index) => {
        line.textContent = lines[index]; line.setAttribute('font-size', String(size));
        line.setAttribute('x', String(widthMm / 2));
        line.setAttribute('y', String(heightMm * (hasSecond ? (index === 0 ? .296 : .72) : .5)));
      });
    }
    function renderInlinePlaque() {
      if (!inlinePlaque) return;
      const lines = [nameInput.value.trim() || 'DEIN NAME', secondInput.value.trim()];
      inlinePlaque.setAttribute('viewBox', `0 0 ${plaqueSize.widthMm} ${plaqueSize.heightMm}`);
      inlinePlaque.setAttribute('aria-label', `Textplakette: ${lines.filter(Boolean).join(' / ')}. Schrift ${fontSelect.options[fontSelect.selectedIndex].text}, ${textColor.value} auf ${plaqueColor.value}.`);
      drawPlaque(inlinePlaque, lines);
    }
    let partInputs = [], renderPlaque = renderInlinePlaque, syncPaidVariant = () => {};
    if (configurable) {
      const parts = definition.parts.map(part => [part.label, part.id, part.colorName, part.property || part.label]);
      const plaquePartIndex = definition.parts.findIndex(part => part.id === 'logo' && part.label === 'Plakette');
      if (plaquePartIndex >= 0) {
        // This model's configurable plaque is also the text background.
        plaqueColor.closest('div').hidden = true;
      }
      let activePart = 0, currentView = definition.defaultView;
      const anchor = new URL(root.dataset.assetAnchor, location.href), asset = name => new URL(name, anchor).href;
      const layerHost = q('[data-stage-layers]', root), properties = q('[data-color-properties]', root);
      const tabs = q('[data-parts]', root), swatchHost = q('[data-swatches]', root);
      const layerImages = [], partButtons = [];
      if (model === 'butler' && colorIndex >= 0) parts[1][2] = normalizedColor(currentOptions[colorIndex])?.[0] || 'Grün';
      const presets = {
        'match-green': parts.map((_, index) => index ? 'Grün' : 'Schwarz'),
        'all-black': parts.map(() => 'Schwarz'),
      };
      if (model === 'case') {
        const preset = Object.hasOwn(presets, params.get('recipe')) ? presets[params.get('recipe')] : undefined;
        parts.forEach((part, index) => {
          const explicit = normalizedColor(params.get(part[1].replaceAll('-', '_')) || params.get(part[1]));
          if (explicit) part[2] = explicit[0]; else if (preset) part[2] = preset[index];
        });
      }
      parts.forEach((part, index) => {
        const input = document.createElement('input'); input.type = 'hidden'; input.name = `properties[${part[3]}]`; input.value = part[2]; properties.append(input); partInputs.push(input);
        const button = document.createElement('button'); button.type = 'button'; button.textContent = part[0]; button.className = 'part-tab';
        button.addEventListener('click', () => { activePart = index; if (model === 'butler' && index === 1) { currentView = 'offen'; renderStage(); } renderSelection(); }); tabs.append(button); partButtons.push(button);
        const img = document.createElement('img'); img.className = 'stage-layer'; img.alt = ''; img.width = 1200; img.height = 1200;
        img.addEventListener('error', () => { q('[data-preview-note]', root).textContent = 'Farbvorschau konnte nicht geladen werden. Deine Auswahl bleibt gespeichert.'; });
        layerHost.append(img); layerImages.push(img);
      });
      function matchingNameVariant(withName) {
        if (personalizationIndex < 0 && withName) return undefined;
        return variants.find(variant => {
          const values = variantOptions(variant);
          return values.every((value, index) => index === personalizationIndex
            ? value === (withName ? 'Mit Textlogo' : 'Ohne Textlogo')
            : index === colorIndex ? normalizedColor(value)?.[0] === partInputs[1].value : value === currentOptions[index]);
        });
      }
      syncPaidVariant = () => {
        const plain = matchingNameVariant(false), named = matchingNameVariant(true);
        const canPersonalize = Boolean(plain && named && named.price > plain.price && named.available);
        personalize.disabled = !canPersonalize;
        if (!canPersonalize) personalize.checked = false;
        q('[data-personalize-label]', root).textContent = canPersonalize ? `Textplakette hinzufügen (+${money(named.price - plain.price)})` : 'Textlogo für diese Auswahl nicht verfügbar';
        const variant = personalize.checked ? named : plain;
        select.value = variant ? String(variant.id) : '';
        if (variant) variantOptions(variant).forEach((value, index) => { currentOptions[index] = value; });
        syncNameFields();
        updatePrice(); renderPlaque();
      };
      const swatches = colors.map(color => {
        const button = createSwatch(color);
        button.addEventListener('click', () => {
          partInputs[activePart].value = color[0];
          showError(error, ''); syncPaidVariant(); renderSelection(); renderStage();
        });
        swatchHost.append(button); return button;
      });
      function renderSelection() {
        partButtons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === activePart)));
        qa('[data-recipe]', root).forEach(button => button.setAttribute('aria-pressed', String(presets[button.dataset.recipe]?.every((color, index) => color === partInputs[index]?.value))));
        swatches.forEach((button, index) => {
          button.setAttribute('aria-pressed', String(colors[index][0] === partInputs[activePart].value));
          // Butler's inner color is a native product option, never a free-form substitution.
          button.disabled = model === 'butler' && activePart === 1 && colorIndex >= 0
            && !variants.some(variant => normalizedColor(variantOptions(variant)[colorIndex])?.[0] === colors[index][0]);
        });
        q('[data-color-label]', root).textContent = `${parts[activePart][0]}: ${partInputs[activePart].value}`;
      }
      function renderStage() {
        photoMode = false;
        if (galleryImage) galleryImage.hidden = true;
        galleryButtons.forEach(button => button.setAttribute('aria-pressed', 'false'));
        const base = q('[data-stage-base]', root); base.hidden = false; layerHost.hidden = false;
        const view = currentView, prefix = definition.prefix;
        base.src = asset(`${definition.folder}-${view}.webp`);
        layerImages.forEach((img, index) => { img.src = asset(`${prefix}-${view}-${parts[index][1]}-${normalizedColor(partInputs[index].value)[1]}.webp`); });
        qa('[data-view]', root).forEach(button => { const active = (button.dataset.view === 'explosion' ? definition.views[1].key : button.dataset.view) === currentView; button.classList.toggle('active', active); button.setAttribute('aria-pressed', String(active)); });
        q('[data-preview-note]', root).textContent = currentView === 'explosion' && model === 'case' ? 'Bauteilansicht, keine Darstellung des Öffnungsmechanismus.' : 'Digitale Vorschau. Druckfarben können abweichen.';
        renderPlaque();
      }
      renderPlaque = () => {
        if (plaquePartIndex >= 0) plaqueColor.value = partInputs[plaquePartIndex].value;
        renderInlinePlaque();
        const plaque = q('[data-stage-plaque]', root), lines = [nameInput.value.trim(), secondInput.value.trim()];
        if (!photoMode) q('[data-preview-note]', root).textContent = currentView === 'explosion' ? 'Bauteilansicht, keine Darstellung des Öffnungsmechanismus.' : 'Digitale Vorschau. Druckfarben können abweichen.';
        const hidden = photoMode || !personalize.checked || !lines[0]; plaque.toggleAttribute('hidden', hidden); if (hidden) return;
        const matrix = definition.views.find(view => view.key === currentView)?.matrix;
        q('[data-plaque-transform]', root).setAttribute('transform', `matrix(${(matrix || [5,0,0,5,450,1000]).join(' ')})`);
        if (!matrix) q('[data-preview-note]', root).textContent = 'Textplakette separat dargestellt. Druckfarben können abweichen.';
        drawPlaque(plaque, lines);
      };
      qa('[data-view]', root).forEach(button => button.addEventListener('click', () => { currentView = button.dataset.view === 'explosion' ? definition.views[1].key : button.dataset.view; renderStage(); }));
      qa('[data-recipe]', root).forEach(button => button.addEventListener('click', () => {
        const preset = presets[button.dataset.recipe]; if (!preset) return;
        preset.forEach((color, index) => { partInputs[index].value = color; }); renderSelection(); renderStage();
      }));
      personalize.checked = personalizationIndex >= 0 && variantOptions(selectedVariant())[personalizationIndex] === 'Mit Textlogo';
      personalize.addEventListener('change', () => { syncPaidVariant(); showError(error, ''); });
      nameFields.addEventListener('input', () => { nameInput.setCustomValidity(''); showError(error, ''); q('[data-name-count]', root).textContent = `${nameInput.value.length}/${nameInput.maxLength}`; renderPlaque(); });
      nameFields.addEventListener('change', () => { showError(error, ''); renderPlaque(); });
      const nameFromHome = params.get('name');
      if (nameFromHome && matchingNameVariant(true)?.available) { nameInput.value = nameFromHome.slice(0, nameInput.maxLength); personalize.checked = true; q('[data-name-count]', root).textContent = `${nameInput.value.length}/${nameInput.maxLength}`; }
      syncPaidVariant(); renderSelection(); renderStage();
      const shareButton = q('[data-share-recipe]', root);
      if (shareButton && model === 'case') {
        shareButton.hidden = false;
        shareButton.addEventListener('click', async () => {
          const url = new URL(root.dataset.productUrl || location.pathname, location.origin); // Build from scratch: omit names, contact data and tracking.
          parts.forEach((part, index) => url.searchParams.set(part[1].replaceAll('-', '_'), normalizedColor(partInputs[index].value)[1]));
          const output = q('[data-share-url]', root); output.value = url.href; output.hidden = false;
          try { await navigator.clipboard.writeText(url.href); q('[data-share-status]', root).textContent = 'Link kopiert'; }
          catch { output.focus(); output.select(); q('[data-share-status]', root).textContent = 'Link zum Kopieren'; }
        });
      }
    }
    if (!configurable && personalize) {
      const findNamed = named => variants.find(variant => variantOptions(variant).every((value, index) => value === (index === personalizationIndex ? (named ? 'Mit Textlogo' : 'Ohne Textlogo') : currentOptions[index])));
      syncSimpleText = () => {
        const plain = personalizationIndex >= 0 ? findNamed(false) : selectedVariant();
        const named = personalizationIndex >= 0 ? findNamed(true) : null;
        const enabled = addonData ? addonAvailable() : Boolean(plain && named && named.available && named.price > plain.price);
        personalize.disabled = !enabled;
        if (!enabled) personalize.checked = false;
        const surcharge = addonData ? plaqueAddon?.price : enabled ? named.price - plain.price : 0;
        q('[data-personalize-label]', root).textContent = enabled ? `Textplakette hinzufügen (+${money(surcharge)})` : 'Textplakette derzeit nicht verfügbar';
        if (personalizationIndex >= 0) {
          const variant = personalize.checked ? named : plain;
          select.value = variant ? String(variant.id) : '';
          currentOptions[personalizationIndex] = personalize.checked ? 'Mit Textlogo' : 'Ohne Textlogo';
        }
        syncNameFields(); updatePrice(); renderPlaque();
      };
      personalize.checked = personalizationIndex >= 0 && variantOptions(selectedVariant())[personalizationIndex] === 'Mit Textlogo';
      personalize.addEventListener('change', () => { syncSimpleText(); showError(error, ''); });
      nameFields.addEventListener('input', () => { nameInput.setCustomValidity(''); showError(error, ''); q('[data-name-count]', root).textContent = `${nameInput.value.length}/${nameInput.maxLength}`; renderPlaque(); });
      nameFields.addEventListener('change', () => { showError(error, ''); renderPlaque(); });
      syncSimpleText();
    }
    updatePrice();
    let pending = false;
    form.addEventListener('submit', async event => {
      event.preventDefault(); if (pending || needsApproval || !addButton) return;
      if (personalize && personalize.checked) {
        const name = nameInput.value.trim();
        if (!name || /[\u0000-\u001f\u007f]/.test(name + secondInput.value)) { nameInput.setCustomValidity('Bitte gib einen druckbaren Namen ein.'); nameInput.reportValidity(); return; }
        if (plaqueColor.value === textColor.value) { showError(error, 'Wähle unterschiedliche Farben für Plakette und Schrift.'); q('[aria-pressed="true"]', textColor.closest('[data-text-color-group]')).focus(); return; }
        if (addonData ? !addonAvailable() : variantOptions(selectedVariant())[personalizationIndex] !== 'Mit Textlogo') { showError(error, 'Bitte wähle die bezahlte Ausführung mit Textlogo.'); return; }
      }
      for (const input of qa('[data-required-print-text]', root)) {
        if (!input.value.trim() || /[\u0000-\u001f\u007f]/.test(input.value)) { input.setCustomValidity('Bitte gib einen druckbaren Text ein.'); input.reportValidity(); return; }
      }
      const foreground = q('[data-service-foreground]', root), background = q('[data-service-background]', root);
      if (foreground && background && foreground.value === background.value) { showError(error, 'Schrift und Hintergrund brauchen unterschiedliche Farben.'); foreground.focus(); return; }
      if (!form.reportValidity()) return;
      if (!selectedVariant()?.available) return;
      pending = true; addButton.disabled = true; addLabel.textContent = 'Wird hinzugefügt …'; showError(error, '');
      try {
        const data = productionFormData(form);
        const options = {method:'POST', body:new URLSearchParams(data), headers:{Accept:'application/json'}};
        if (addonData && personalize.checked) {
          // Keep the original product variant (and its stock), charging the existing plaque SKU once per item.
          const group = crypto.randomUUID();
          const properties = Object.fromEntries([...data].filter(([key]) => /^properties\[.+\]$/.test(key)).map(([key,value]) => [key.slice(11,-1),String(value).trim()]));
          properties._plaque_group = group; properties._plaque_role = 'product';
          properties._plaque_addon_variant = String(plaqueAddon.id);
          const variant = selectedVariant(), quantity = Number(data.get('quantity'));
          const plaqueProperties = {
            Zuordnung:(product.title + (variant.title === 'Default Title' ? '' : ` · ${variant.title}`)).slice(0,200),
            Text:properties.Textlogo, Text2:properties['Textlogo Zeile 2'],
            Schriftart:properties.Schrift === 'Script' ? 'Schreibschrift' : properties.Schrift,
            Schriftfarbe:properties.Textfarbe, Hintergrundfarbe:properties.Plakettenfarbe,
            _plaque_group:group, _plaque_role:'addon', _plaque_parent_variant:String(variant.id),
          };
          options.body = JSON.stringify({items:[{id:variant.id,quantity,properties},{id:plaqueAddon.id,quantity,properties:plaqueProperties}]});
          options.headers['Content-Type'] = 'application/json';
        }
        const response = await fetch(route('cart/add.js'), options);
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Das Produkt konnte nicht hinzugefügt werden. Bitte erneut versuchen.');
        location.assign(route('cart'));
      } catch (failure) { showError(error, failure instanceof Error ? failure.message : 'Verbindung fehlgeschlagen. Bitte erneut versuchen.'); }
      finally { pending = false; updatePrice(); }
    });
    // Refit both previews after the bundled script font loads, using its actual letter widths.
    if (personalize && document.fonts) document.fonts.load('400 100px Pacifico').then(() => renderPlaque()).catch(() => {});
    textReady = true;
    updatePrice();
    if (configurable) initMobilePreview(root);
  }

  function initMobilePreview(root) {
    const source = q('.product-visual', root), stage = q('[data-stage]', source);
    const form = q('#product-form', root), start = q('.color-config', form);
    const sourceViews = qa('[data-view]', source), mobile = matchMedia('(max-width: 600px)');
    if (!stage || !start) return;

    const dock = document.createElement('aside');
    dock.className = 'mobile-product-preview'; dock.hidden = true;
    dock.setAttribute('aria-label', 'Produktvorschau');
    dock.innerHTML = '<div class="mobile-preview-content"><div class="mobile-preview-image"><button type="button" class="mobile-preview-enlarge" aria-label="Vorschau vergrößern" aria-haspopup="dialog"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5"/></svg></button></div><div class="view-controls mobile-preview-controls" aria-label="Produktansicht"></div></div>';
    const dialog = document.createElement('dialog');
    dialog.className = 'mobile-preview-dialog'; dialog.setAttribute('aria-label', 'Produktvorschau');
    dialog.innerHTML = '<button type="button" class="mobile-preview-close" aria-label="Vorschau schließen" autofocus><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg></button>';
    root.append(dock, dialog);
    const content = q('.mobile-preview-content', dock), image = q('.mobile-preview-image', dock);
    const enlarge = q('.mobile-preview-enlarge', dock), controls = q('.mobile-preview-controls', dock);
    let lastView = sourceViews.find(button => button.classList.contains('active')) || sourceViews[0];
    const viewButtons = sourceViews.map(sourceButton => {
      const button = document.createElement('button'); button.type = 'button'; button.textContent = sourceButton.textContent;
      button.addEventListener('click', () => sourceButton.click());
      sourceButton.addEventListener('click', () => { lastView = sourceButton; });
      controls.append(button); return button;
    });
    let copy, frame = 0, dirty = true, active = false;
    const viewport = window.visualViewport;
    const typing = () => form.contains(document.activeElement) && document.activeElement.matches('input[type="text"],input[type="number"],textarea');
    function syncPreview() {
      // Mirror the rendered stage, without duplicating the configurator's selectors or state.
      const next = stage.cloneNode(true);
      [next, ...qa('*', next)].forEach(element => {
        [...element.attributes].filter(attribute => attribute.name.startsWith('data-') || attribute.name === 'id').forEach(attribute => element.removeAttribute(attribute.name));
      });
      next.setAttribute('aria-hidden', 'true');
      if (copy) copy.replaceWith(next); else image.prepend(next);
      copy = next;
      viewButtons.forEach((button, index) => {
        const selected = sourceViews[index].getAttribute('aria-pressed') === 'true';
        button.classList.toggle('active', selected); button.setAttribute('aria-pressed', String(selected));
      });
      dirty = false;
    }
    function update() {
      frame = 0;
      const editing = typing(), viewportHeight = viewport?.height || innerHeight;
      const top = viewport?.offsetTop || 0;
      const regularHeight = Math.max(168, Math.min(264, viewportHeight * .31));
      const height = editing ? Math.max(112, Math.min(144, viewportHeight * .28)) : regularHeight;
      const bottom = form.getBoundingClientRect().bottom;
      active = mobile.matches && stage.getBoundingClientRect().bottom < top && (editing || start.getBoundingClientRect().top < top + regularHeight + 16) && bottom > top + height;
      if (!mobile.matches && dialog.open) dialog.close();
      dock.hidden = !active || dialog.open;
      dock.style.top = `${top}px`;
      dock.style.setProperty('--mobile-preview-height', `${height}px`);
      document.documentElement.style.setProperty('--config-preview-offset', active ? `${height + 16}px` : '0px');
      const photo = q('[data-gallery-image]', source);
      if (active && photo && !photo.hidden) lastView?.click();
      if ((active || dialog.open) && dirty) syncPreview();
    }
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const observer = new MutationObserver(() => { dirty = true; schedule(); });
    observer.observe(source, {subtree:true, childList:true, attributes:true, characterData:true});
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule, {passive:true});
    mobile.addEventListener('change', schedule);
    form.addEventListener('focusin', schedule);
    form.addEventListener('focusout', schedule);
    viewport?.addEventListener('scroll', schedule, {passive:true});
    viewport?.addEventListener('resize', () => {
      schedule();
      if (!mobile.matches || !typing() || dialog.open) return;
      requestAnimationFrame(() => {
        const field = document.activeElement.getBoundingClientRect();
        const lowerEdge = viewport.offsetTop + viewport.height - 16;
        const upperEdge = dock.getBoundingClientRect().bottom + 16;
        if (field.bottom > lowerEdge) window.scrollBy(0, field.bottom - lowerEdge);
        else if (active && field.top < upperEdge) window.scrollBy(0, field.top - upperEdge);
      });
    }, {passive:true});
    enlarge.addEventListener('click', () => {
      if (!mobile.matches) return;
      if (dirty) syncPreview();
      dialog.append(content); dialog.showModal();
      document.body.classList.add('mobile-preview-modal-open');
      schedule();
    });
    q('.mobile-preview-close', dialog).addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      dock.append(content); document.body.classList.remove('mobile-preview-modal-open');
      update();
      if (active) enlarge.focus({preventScroll:true});
    });
    schedule();
  }

  const cartForm = q('[data-cart-form]');
  if (cartForm) {
    cartForm.addEventListener('submit', event => {
      const missingText = q('[data-missing-textlogo],[data-invalid-plaque]', cartForm);
      if (event.submitter?.name === 'checkout') {
        if (updating || missingText) event.preventDefault();
        if (missingText) q('a', missingText).focus();
      }
    });
    let updating = false;
    async function changeLine(line, quantity) {
      if (updating) return;
      updating = true;
      const controls = qa('input,button', cartForm); controls.forEach(control => { control.disabled = true; });
      showError(q('[data-cart-error]'), '');
      let changed = false, uncertain = false;
      try {
        const linked = line.dataset.plaqueGroup ? qa('[data-plaque-group]', cartForm).filter(item => item.dataset.plaqueGroup === line.dataset.plaqueGroup) : [];
        // change.js validates stock; update.js can exceed inventory for existing cart lines.
        // Update the stock-bearing product first, then its plaque. Resolve fresh keys after each response.
        const targets = linked.length ? linked.sort((a,b) => Number(b.dataset.plaqueRole === 'product') - Number(a.dataset.plaqueRole === 'product')) : [line];
        let latest, pairedQuantity = quantity;
        for (const target of targets) {
          const current = latest?.items.find(item => item.properties?._plaque_group === target.dataset.plaqueGroup && item.properties?._plaque_role === target.dataset.plaqueRole);
          if (latest && !current) throw new Error('Die zugehörige Position fehlt. Bitte prüfe den Warenkorb.');
          uncertain = true;
          const response = await fetch(route('cart/change.js'), {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:current?.key || target.dataset.lineKey,quantity:pairedQuantity})});
          const result = await response.json();
          uncertain = false;
          if (!response.ok) throw new Error(result.description || 'Warenkorb konnte nicht aktualisiert werden.');
          changed = true; latest = result;
          if (target.dataset.plaqueRole === 'product' && quantity > 0) {
            const product = latest.items.find(item => item.properties?._plaque_group === target.dataset.plaqueGroup && item.properties?._plaque_role === 'product');
            if (!product) throw new Error('Das Produkt fehlt. Bitte prüfe den Warenkorb.');
            pairedQuantity = product.quantity;
          }
        }
        location.reload();
      } catch (error) {
        // A partial update must show the actual cart and its pair-validation guard before checkout.
        if (changed || uncertain) { location.reload(); return; }
        showError(q('[data-cart-error]'), error.message || 'Verbindung fehlgeschlagen.');
        controls.forEach(control => { control.disabled = false; });
        qa('[data-cart-quantity]', cartForm).forEach(input => { input.value = input.defaultValue; });
        q('[name="checkout"]', cartForm).disabled = Boolean(q('[data-missing-textlogo],[data-invalid-plaque]', cartForm)); updating = false;
      }
    }
    qa('[data-cart-quantity]', cartForm).forEach(input => input.addEventListener('change', () => {
      const value = Number(input.value);
      if (!Number.isInteger(value) || value < 0 || value > 99) { showError(q('[data-cart-error]'), 'Bitte eine Menge von 0 bis 99 eingeben.'); input.reportValidity(); return; }
      changeLine(input.closest('[data-line-key]'),value);
    }));
    qa('[data-cart-remove]', cartForm).forEach(link => link.addEventListener('click', event => { event.preventDefault(); changeLine(link.closest('[data-line-key]'),0); }));
  }
})();
